import { getUtk } from 'usage-tracker-core/common/defaultTrackers'; // this should be used only on initialization asap
// Resolves to the UTK when the user accepts cookies

export const getTrackerHstc = () => {
  return new Promise(resolve => {
    const interval = setInterval(() => {
      if (getUtk()) {
        clearInterval(interval);
        resolve(`x.${getUtk()}`);
      }
    }, 100);
  });
};